import React from "react";

/**
 * LiquiMolyBadge — logo de la Liqui Moly StarLigue, image servie via proxy
 * pour bypass CORS. Cliquable, ouvre le site officiel.
 */
const SIZES = { sm: "h-[18px]", md: "h-6", lg: "h-8", xl: "h-11" };

const LIQUI_MOLY_LOGO = "/api/sport/asset?url=https%3A%2F%2Flnh.fr%2Fmedias%2Fsports_competitions%2Fliqui-moly-starligue-logo.png";

export function LiquiMolyBadge({ size = "md", className = "", "data-testid": testid = "liqui-moly-badge" }) {
  const sizeCls = SIZES[size] || SIZES.md;
  return (
    <a
      href="https://www.lnh.fr/liquimoly-starligue"
      target="_blank"
      rel="noopener noreferrer"
      title="Liqui Moly StarLigue — Championnat de France"
      className={`inline-flex items-center align-middle hover:opacity-80 transition ${className}`}
      data-testid={testid}
      onClick={(e) => e.stopPropagation()}
    >
      <img src={LIQUI_MOLY_LOGO} alt="Liqui Moly StarLigue" className={`${sizeCls} w-auto object-contain`} loading="lazy"
        onError={(e) => { e.currentTarget.style.display = "none"; }}/>
    </a>
  );
}

export default LiquiMolyBadge;
